import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import t from '../../lib/I18n';
import Icon from '../general/Icon';

PasswordHint.propTypes = {
    type: PropTypes.string.isRequired,
    ok: PropTypes.bool,
    mini: PropTypes.bool,
    labelProps: PropTypes.object,
};

export default function PasswordHint({ type, ok = false, mini = false, labelProps = {} }) {
    return (
        <div
            className={cn('password-hint', `password-hint__${type}`, 'sr-container', {
                'password-hint__ok': ok,
            })}
        >
            {mini && <Icon icon="tick" className="otrl-inline margin-right--xs" />}
            {t(`passwordHint.${type}`, labelProps)}&nbsp;
            {ok && !mini && <Icon icon="tick-circle" srOnly={t('passwordHint.itemOk')} />}&nbsp;
            <span className="sr-text">
                {ok ? t('passwordHint.itemOk') : t('passwordHint.itemNotOk')}
            </span>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/customer/PasswordHint.js